/* cardframes — Texte des Kunden-Konfigurators.
 *
 * Hier steht ausschließlich Sprache, keine Logik. Formulierungen lassen sich
 * gefahrlos ändern; {n}, {name} und {rahmen} werden eingesetzt.
 *
 * Eine Sprache dazunehmen: Block kopieren, Kürzel anpassen, übersetzen, Flagge
 * ergänzen. Der Konfigurator erkennt sie automatisch.
 *
 * Die Flaggen sind gezeichnet, nicht als Emoji eingesetzt: Windows stellt
 * Flaggen-Emoji nur als Buchstabenpaar dar.
 *
 * Die Farbnamen unter `farben` sind Anzeigetexte. Der interne Name aus dem
 * Katalog (Schwarz / Weiß) bleibt unangetastet — er ist der Schlüssel zur
 * Shopify-Variante und darf sich nie mit der Sprache ändern.
 */
window.CARDFRAMES_TEXTE = {
  de: {
    _name: 'Deutsch',
    _flagge:
      '<svg viewBox="0 0 24 16" aria-hidden="true"><rect width="24" height="16" fill="#000"/>' +
      '<rect y="5.33" width="24" height="5.34" fill="#DD0000"/>' +
      '<rect y="10.67" width="24" height="5.33" fill="#FFCE00"/></svg>',
    titel: 'Bau deinen Rahmen',
    untertitel:
      'Format wählen, Karten reinlegen, fertig. Wir schneiden das Inlay millimetergenau für dich.',
    schrittFormat: 'Format',
    versandfrei: 'Ab {betrag} versandkostenfrei — dir fehlen noch {rest}.',
    hochformat: 'Hochformat',
    querformat: 'Querformat',
    eigAusrichtung: 'Ausrichtung',
    schrittFarbe: 'Rahmenfarbe',
    schrittInhalt: 'Was kommt rein?',
    bis: 'bis {n}',
    passtNicht: 'passt nicht',
    imRahmen: 'Im Rahmen',
    allesEntfernen: 'Alles entfernen',
    leer: 'Noch leer',
    eineKarte: '1 Karte im Rahmen',
    vieleKarten: '{n} Karten im Rahmen',
    drehTipp: 'Karte antippen zum Drehen',
    bildLeer: 'Wähle aus, was hineinsoll',
    vollTitel: 'Der Rahmen ist voll.',
    vollMit: 'Mit {rahmen} hättest du Platz — ein Klick wechselt.',
    vollOder: ' oder ',
    vollEnde: 'Mehr passt in keinen unserer Rahmen.',
    kaufen: 'In den Warenkorb',
    kaufenLaeuft: 'Wird hinzugefügt …',
    kaufenFehler: 'Das hat gerade nicht geklappt. Bitte nochmal versuchen.',
    vertrauen: ['Handgefertigt in Deutschland', 'Passgenau lasergeschnitten', 'Sicher verpackt'],
    eigRahmen: 'Rahmen',
    eigFarbe: 'Farbe',
    eigInhalt: 'Bestückung',
    ariaDrehen: '{name} drehen',
    ariaWeniger: 'Ein {name} weniger',
    ariaMehr: 'Ein {name} mehr',
    ariaEntfernen: '{name} entfernen',
    ariaBild: 'Vorschau deines Rahmens',
    ariaSprache: 'Sprache wählen',
    farben: { Schwarz: 'Schwarz', 'Weiß': 'Weiß' },
  },

  en: {
    _name: 'English',
    _flagge:
      '<svg viewBox="0 0 24 16" aria-hidden="true"><rect width="24" height="16" fill="#012169"/>' +
      '<path d="M0 0 L24 16 M24 0 L0 16" stroke="#fff" stroke-width="3.2"/>' +
      '<path d="M0 0 L24 16 M24 0 L0 16" stroke="#C8102E" stroke-width="1.7"/>' +
      '<path d="M12 0 V16 M0 8 H24" stroke="#fff" stroke-width="5.2"/>' +
      '<path d="M12 0 V16 M0 8 H24" stroke="#C8102E" stroke-width="3.1"/></svg>',
    titel: 'Build your frame',
    untertitel:
      'Pick a size, drop your cards in, done. We laser-cut the insert to the millimetre for you.',
    schrittFormat: 'Size',
    versandfrei: 'Free shipping from {betrag} — you are {rest} away.',
    hochformat: 'Portrait',
    querformat: 'Landscape',
    eigAusrichtung: 'Orientation',
    schrittFarbe: 'Frame colour',
    schrittInhalt: 'What goes in?',
    bis: 'up to {n}',
    passtNicht: "doesn't fit",
    imRahmen: 'In the frame',
    allesEntfernen: 'Remove all',
    leer: 'Still empty',
    eineKarte: '1 card in the frame',
    vieleKarten: '{n} cards in the frame',
    drehTipp: 'Tap a card to rotate it',
    bildLeer: 'Choose what goes inside',
    vollTitel: 'This frame is full.',
    vollMit: '{rahmen} would give you room — one click switches.',
    vollOder: ' or ',
    vollEnde: "It won't fit in any of our frames.",
    kaufen: 'Add to cart',
    kaufenLaeuft: 'Adding …',
    kaufenFehler: "That didn't work. Please try again.",
    vertrauen: ['Handmade in Germany', 'Precision laser-cut', 'Shipped safely'],
    eigRahmen: 'Frame',
    eigFarbe: 'Colour',
    eigInhalt: 'Contents',
    ariaDrehen: 'Rotate {name}',
    ariaWeniger: 'One {name} less',
    ariaMehr: 'One {name} more',
    ariaEntfernen: 'Remove {name}',
    ariaBild: 'Preview of your frame',
    ariaSprache: 'Choose language',
    farben: { Schwarz: 'Black', 'Weiß': 'White' },
  },

  fr: {
    _name: 'Français',
    _flagge:
      '<svg viewBox="0 0 24 16" aria-hidden="true"><rect width="24" height="16" fill="#fff"/>' +
      '<rect width="8" height="16" fill="#002395"/>' +
      '<rect x="16" width="8" height="16" fill="#ED2939"/></svg>',
    titel: 'Composez votre cadre',
    untertitel:
      'Choisissez le format, placez vos cartes, c’est tout. Nous découpons l’insert au millimètre près.',
    schrittFormat: 'Format',
    versandfrei: 'Livraison offerte dès {betrag} — il vous manque {rest}.',
    hochformat: 'Portrait',
    querformat: 'Paysage',
    eigAusrichtung: 'Orientation',
    schrittFarbe: 'Couleur du cadre',
    schrittInhalt: 'Que met-on dedans ?',
    bis: "jusqu'à {n}",
    passtNicht: 'ne rentre pas',
    imRahmen: 'Dans le cadre',
    allesEntfernen: 'Tout retirer',
    leer: 'Encore vide',
    eineKarte: '1 carte dans le cadre',
    vieleKarten: '{n} cartes dans le cadre',
    drehTipp: 'Touchez une carte pour la tourner',
    bildLeer: 'Choisissez ce qui va à l’intérieur',
    vollTitel: 'Ce cadre est plein.',
    vollMit: 'Avec {rahmen}, vous auriez de la place — un clic suffit.',
    vollOder: ' ou ',
    vollEnde: 'Cela ne rentre dans aucun de nos cadres.',
    kaufen: 'Ajouter au panier',
    kaufenLaeuft: 'Ajout en cours …',
    kaufenFehler: 'Cela n’a pas fonctionné. Veuillez réessayer.',
    vertrauen: ['Fabriqué en Allemagne', 'Découpe laser précise', 'Emballage soigné'],
    eigRahmen: 'Cadre',
    eigFarbe: 'Couleur',
    eigInhalt: 'Contenu',
    ariaDrehen: 'Tourner {name}',
    ariaWeniger: 'Un {name} de moins',
    ariaMehr: 'Un {name} de plus',
    ariaEntfernen: 'Retirer {name}',
    ariaBild: 'Aperçu de votre cadre',
    ariaSprache: 'Choisir la langue',
    farben: { Schwarz: 'Noir', 'Weiß': 'Blanc' },
  },

  es: {
    _name: 'Español',
    _flagge:
      '<svg viewBox="0 0 24 16" aria-hidden="true"><rect width="24" height="16" fill="#AA151B"/>' +
      '<rect y="4" width="24" height="8" fill="#F1BF00"/></svg>',
    titel: 'Crea tu marco',
    untertitel:
      'Elige el formato, coloca tus cartas y listo. Cortamos el interior a láser al milímetro.',
    schrittFormat: 'Formato',
    versandfrei: 'Envío gratis desde {betrag} — te faltan {rest}.',
    hochformat: 'Vertical',
    querformat: 'Horizontal',
    eigAusrichtung: 'Orientación',
    schrittFarbe: 'Color del marco',
    schrittInhalt: '¿Qué va dentro?',
    bis: 'hasta {n}',
    passtNicht: 'no cabe',
    imRahmen: 'En el marco',
    allesEntfernen: 'Quitar todo',
    leer: 'Aún vacío',
    eineKarte: '1 carta en el marco',
    vieleKarten: '{n} cartas en el marco',
    drehTipp: 'Toca una carta para girarla',
    bildLeer: 'Elige qué va dentro',
    vollTitel: 'El marco está lleno.',
    vollMit: 'Con {rahmen} tendrías espacio — un clic lo cambia.',
    vollOder: ' o ',
    vollEnde: 'No cabe en ninguno de nuestros marcos.',
    kaufen: 'Añadir al carrito',
    kaufenLaeuft: 'Añadiendo …',
    kaufenFehler: 'No ha funcionado. Inténtalo de nuevo.',
    vertrauen: ['Hecho en Alemania', 'Corte láser preciso', 'Envío bien protegido'],
    eigRahmen: 'Marco',
    eigFarbe: 'Color',
    eigInhalt: 'Contenido',
    ariaDrehen: 'Girar {name}',
    ariaWeniger: 'Un {name} menos',
    ariaMehr: 'Un {name} más',
    ariaEntfernen: 'Quitar {name}',
    ariaBild: 'Vista previa de tu marco',
    ariaSprache: 'Elegir idioma',
    farben: { Schwarz: 'Negro', 'Weiß': 'Blanco' },
  },

  it: {
    _name: 'Italiano',
    _flagge:
      '<svg viewBox="0 0 24 16" aria-hidden="true"><rect width="24" height="16" fill="#fff"/>' +
      '<rect width="8" height="16" fill="#008C45"/>' +
      '<rect x="16" width="8" height="16" fill="#CD212A"/></svg>',
    titel: 'Crea la tua cornice',
    untertitel:
      'Scegli il formato, inserisci le carte, fatto. Tagliamo l’inserto al laser al millimetro.',
    schrittFormat: 'Formato',
    versandfrei: 'Spedizione gratuita da {betrag} — ti mancano {rest}.',
    hochformat: 'Verticale',
    querformat: 'Orizzontale',
    eigAusrichtung: 'Orientamento',
    schrittFarbe: 'Colore della cornice',
    schrittInhalt: 'Cosa ci va dentro?',
    bis: 'fino a {n}',
    passtNicht: 'non ci sta',
    imRahmen: 'Nella cornice',
    allesEntfernen: 'Rimuovi tutto',
    leer: 'Ancora vuota',
    eineKarte: '1 carta nella cornice',
    vieleKarten: '{n} carte nella cornice',
    drehTipp: 'Tocca una carta per ruotarla',
    bildLeer: 'Scegli cosa mettere dentro',
    vollTitel: 'La cornice è piena.',
    vollMit: 'Con {rahmen} avresti spazio — un clic cambia.',
    vollOder: ' o ',
    vollEnde: 'Non ci sta in nessuna delle nostre cornici.',
    kaufen: 'Aggiungi al carrello',
    kaufenLaeuft: 'Aggiunta in corso …',
    kaufenFehler: 'Non ha funzionato. Riprova.',
    vertrauen: ['Fatto a mano in Germania', 'Taglio laser preciso', 'Imballato con cura'],
    eigRahmen: 'Cornice',
    eigFarbe: 'Colore',
    eigInhalt: 'Contenuto',
    ariaDrehen: 'Ruota {name}',
    ariaWeniger: 'Un {name} in meno',
    ariaMehr: 'Un {name} in più',
    ariaEntfernen: 'Rimuovi {name}',
    ariaBild: 'Anteprima della tua cornice',
    ariaSprache: 'Scegli la lingua',
    farben: { Schwarz: 'Nero', 'Weiß': 'Bianco' },
  },
};
